export default __webpack_public_path__ + "static/media/glass_b.d9a145e8.svg";